import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsentBanner.css';

export default function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('cookie_consent');
      if (!consent) {
        const timer = setTimeout(() => setIsVisible(true), 500);
        return () => clearTimeout(timer);
      }
    } catch {
      // Ignore private storage restrictions
    }
  }, []);

  const handleChoice = (choice) => {
    try {
      localStorage.setItem('cookie_consent', choice);
    } catch {
      // Ignore
    }
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 250);
  };

  if (!isVisible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent banner"
      className={`cookie-consent-wrapper ${isClosing ? 'closing' : ''}`}
    >
      <div className="cookie-consent-card">
        <p className="cookie-consent-text">
          We use cookies to improve your experience and analyse site traffic. See our{' '}
          <Link to="/privacy-policy" className="cookie-consent-link">
            Privacy Policy
          </Link>
          .
        </p>

        <div className="cookie-consent-actions">
          <button
            type="button"
            onClick={() => handleChoice('declined')}
            className="cookie-btn-decline"
          >
            Essential Only
          </button>
          <button
            type="button"
            onClick={() => handleChoice('accepted')}
            className="cookie-btn-accept"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
